import {
  FEATURED_SHADERS_KEY,
  RECENT_SHADERS_KEY,
  POPULAR_SHADERS_KEY,
} from '../actions/shaders';

export const featuredShaders = ({ shaders }) => shaders[FEATURED_SHADERS_KEY] || [];
export const recentShaders = ({ shaders }) => shaders[RECENT_SHADERS_KEY] || [];
export const popularShaders = ({ shaders }) => shaders[POPULAR_SHADERS_KEY] || [];
